import { z } from "zod";
import { SortOrder, DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "../constants/api.constants";
import { paginationMetaSchema } from "./base-api-response";

export interface IPaginationMeta {
  totalCount: number;
  pageSize: number;
  limit?: number;
  currentPage: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export interface IPaginationSummary {
  firstItem: number;
  lastItem: number;
  totalCount: number;
}

/**
 * Page number schema for pagination
 */
export const pageNumberSchema = z.coerce.number().default(DEFAULT_PAGE).describe("Page number");

/**
 * Page size schema for pagination
 */
export const pageSizeSchema = z.coerce.number().default(DEFAULT_PAGE_SIZE).describe("Number of items per page");

/**
 * Zod schema for pagination data
 */
export const paginationSchema = z.object({
    page: pageNumberSchema.optional(),
    limit: pageSizeSchema.optional(),
    sortBy: z.string().optional(),
    sortDirection: z.nativeEnum(SortOrder).optional(),
});

export type PaginationDto = z.infer<typeof paginationSchema>;

/**
 * Helper to create a paginated response schema
 * @param itemSchema - Zod schema for individual items in the list
 * @returns Zod schema for paginated response
 */
export const createPaginatedResponseSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.object({
    items: z.array(itemSchema),
    meta: paginationMetaSchema,
  });
